import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faHome, faMagnifyingGlass, faMapLocationDot, faUser,
} from '@fortawesome/free-solid-svg-icons';
import { ROUTES } from '../../constants';
import './style.scss';

library.add(faHome, faUser, faMapLocationDot, faMagnifyingGlass);

function Navbar() {
  const routes = {
    // TODO: make sure Profile page is unneeded
    // [ROUTES.PROFILE]: ['Profile', 'user'],
    [ROUTES.MY_TRIPS]: ['My Trips', 'map-location-dot'],
    [ROUTES.COMMUNITY]: ['Community', 'magnifying-glass'],
  };
  const activeRoute = useLocation().pathname;

  return (
    <header className="nav-bar">
      <div className="nav-bar-logo">XING</div>
      <div className="nav-bar-links">
        {Object.keys(routes).map((route) => (
          <Link
            key={route}
            className={`nav-bar-link ${activeRoute === route ? 'nav-button-active' : 'nav-button'}`}
            to={route}
          >
            <div className="navbar-item">
              <FontAwesomeIcon icon={`fa-solid fa-${routes[route][1]}`} className="fa-icon" />
              <span className="navbar-item-text" style={{ marginTop: '8px', fontSize: '14px' }}>{routes[route][0]}</span>
            </div>
          </Link>
        ))}
      </div>
      <div className="signout">Sign Out</div>
    </header>
  );
}

export default Navbar;
